import { Button, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import { LeftChevron } from "../../../common/js/icons";

const StyledPageToolbar = styled("div")({
    margin: "20px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
});

const StyledPageToolbarBackNavigation = styled("div")({
    display: "flex",
    paddingBottom: "2px",
    paddingRight: "0px",
    flexDirection: "row",
    alignItems: "end",
});

const StyledLeftIcon = styled("div")({
    marginLeft: "25px",
});

const StyledProgressDiv = styled("div")({
    textAlign: "center",
    width: "5em",
    display: "inline-block",
});

const AddContactToolbar = (props) => {
    const { createContact, elementsSaving, newContact, updateContact } = props;

    const navigate = useNavigate();

    const handleSaveContact = async () => {
        const result = newContact ? await createContact() : await updateContact();
        if (result.success) {
            navigate("/contacts");
        }
    };

    const handleCancelChanges = () => {
        navigate("/contacts");
    };

    return (
        <StyledPageToolbar>
            <StyledPageToolbarBackNavigation>
                <Link to="/contacts">
                    <LeftChevron />
                </Link>
                <h2 className="page-title">{newContact ? "Add New Contact" : "Edit Contact"}</h2>
            </StyledPageToolbarBackNavigation>

            <StyledLeftIcon>
                <Button variant="outlined" color="primary" onClick={handleCancelChanges}>
                    Cancel
                </Button>
                {elementsSaving.submit ? (
                    <StyledProgressDiv>
                        <CircularProgress size={20} color="primary" />
                    </StyledProgressDiv>
                ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        // onClick={newContact ? handleSaveContactcreateContact : updateContact}
                        onClick={handleSaveContact}
                    >
                        Save
                    </Button>
                )}
            </StyledLeftIcon>
        </StyledPageToolbar>
    );
};

export default AddContactToolbar;
